import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { GameCenterComponentGridAreas } from '../../styles';
import { PlayersToWatchContainer } from '../playersToWatch/styles';

export const GoalieComparisonContainer = styled(PlayersToWatchContainer)`
    ${BaseStyle.Mixins.gaps.semiLarge}
    display: flex;
    flex-direction: column;
    grid-area: ${GameCenterComponentGridAreas.goalieComparison};
    padding: 24px 0;

    ${BaseStyle.Mixins.screenSizes.medium} {
        border: solid 1px ${({ theme }) => theme.Surface.border};
        border-radius: 4px;
        padding: 24px;
    }
`;

export const TeamGoaltenderStatContainer = styled.div`
    ${BaseStyle.Mixins.gaps.large}
    display: flex;
    flex-direction: column;
`;
